/**
 * Chapter015.js — Plant & Equipment Policy (OHSE 015)
 * Migrated from SWMS Platform Chapter015.tsx → JavaScript
 *
 * Static policy text only — company name is the only variable.
 *
 * Props:
 *   companyName {string}  from companyInfo.name
 */

export default function Chapter015({ companyName }) {
  const cn = companyName || '[Company Name]';
  const Co = () => <span className="font-semibold text-[#c9a84c]">{cn}</span>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">OHSE 015</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">Plant &amp; Equipment</h2>
      </div>

      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <div className="px-4 py-2.5 bg-[#f0ede6]">
          <h3 className="text-sm font-semibold text-[#1a1a2e] uppercase tracking-wide">Plant &amp; Equipment</h3>
          <p className="text-xs text-gray-500 mt-0.5">Inspection and maintenance of plant and equipment</p>
        </div>
        <div className="p-6 space-y-3 text-sm text-[#1a1a2e] leading-relaxed">
          <p><Co /> carries out regular inspections and maintenance of all plant and equipment.</p>
          <p>
            <Co /> ensures plant and equipment is inspected and maintained in accordance with the
            relevant standard and manufacturer's recommendations.
          </p>
          <p>The inspection and maintenance history of each item is documented.</p>
          <p>
            Certain items of plant and equipment will be 'Item Registered' and or 'Design Registered'
            by the Regulatory Authority where required by Legislation.
          </p>
          <p>
            <Co /> ensures control measures are implemented and documented for all plant and equipment,
            including its operation, deemed as high risk. The effect of all plant and equipment on the
            workplace is considered and documented in the Safe Work Method Statement.
          </p>
          <p>
            Pre-start checks, schedule of maintenance and fault reports are notified to the Works
            Supervisor, documented in plant logbooks and made available to relevant parties on request.
          </p>
          <p>Where plant and equipment are hired, the same requirements as above apply.</p>
        </div>
      </div>
    </div>
  );
}
